import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';

//import components
import DetailsListItemContent from './DetailsListItemContent.js';

class DetailsListItemSingle extends Component {
    render() {
        const {label, shortDescription, recordsNumber, id, currentHeading, setActiveElem} = this.props;

        return (
            <li className="structure__list-item--single">
                <div className="structure__list-item--single__container">
                    <DetailsListItemContent setActiveElem={setActiveElem} id={id} label={label} currentHeading={currentHeading} shortDescription={shortDescription} recordsNumber={recordsNumber}/>
                </div>
            </li>
        );
    };
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(DetailsListItemSingle));



// WEBPACK FOOTER //
// ./src/components/characteristics-details/DetailsListItemSingle.js